/**
 * 定义用户基本和操作的仓库
 */
import Vue from "vue";
import loginBksApi from "@/api/room/login";
import systemBksApi from "@/api/system/system";
import {
  ACCESS_TOKEN,
  USER_INFO,
  ACCOUNT_TYPE,
  ACCOUNT_TYPE_INFO
} from "./mutaion-types";
import { welcome } from "@/utils/util";
import { getInfo } from "./data";

const user = {
  state: {
    token: "",
    name: "",
    welcome: "",
    avatar: "",
    roles: [],
    permissions: [],
    info: {},
    accountType: ""
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name;
      if (welcome) {
        state.welcome = welcome;
      }
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMSISSION: (state, perms) => {
      state.permissions = perms;
    },
    SET_INFO: (state, info) => {
      state.info = info;
    },
    SET_ACCOUNT_TYPE: (state, value) => {
      state.accountType = value;
    }
  },

  actions: {
    //登录
    Login({ commit }, userInfo) {
      //异步，返回 一个Promise
      return new Promise((resolve, reject) => {
        Vue.ls.set(ACCOUNT_TYPE, ACCOUNT_TYPE_INFO.NORMAL);
        loginBksApi.merchantUserLogin(userInfo).then(res => {
          if (res) {
            const info = res.resultObject;
            if (info.userType == "1") {
              reject({
                message: "非管家或商户不能登陆"
              });
              return;
            }
            info.avatar = info.imageUrl
              ? info.imageUrl
              : "https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png";

            info.role = [];
            info.perms = ["dashboard"];
            info.userName = info.nickName;
            Vue.ls.set(ACCESS_TOKEN, info.token);
            Vue.ls.set(USER_INFO, info);
            commit("SET_TOKEN", info.token);
            commit("SET_INFO", info);
            commit("SET_ACCOUNT_TYPE", ACCOUNT_TYPE_INFO.NORMAL);
          }
          resolve(res);
        });
      });
    },
    //系统管理用户登录
    AdminLogin({ commit }, userInfo) {
      //异步，返回 一个Promise
      return new Promise((resolve, reject) => {
        Vue.ls.set(ACCOUNT_TYPE, ACCOUNT_TYPE_INFO.SYSTEM);
        systemBksApi.userLogin(userInfo).then(res => {
          if (res && res.resultObject && res.result == 0) {
            let info = res.resultObject;
            if (!info.avatar) {
              info.avatar =
                "https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png";
            }
            Vue.ls.set(ACCESS_TOKEN, info.token);
            Vue.ls.set(USER_INFO, info);
            commit("SET_TOKEN", info.token);
            commit("SET_INFO", info);
            commit("SET_ACCOUNT_TYPE", ACCOUNT_TYPE_INFO.SYSTEM);
          }
          resolve(res);
        });
      });
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        const result = Vue.ls.get(USER_INFO);
        commit("SET_ROLES", result.role ? result.role : []);
        commit("SET_PERMSISSION", result.perms);
        commit("SET_INFO", result);
        commit("SET_NAME", {
          name: result.userName,
          welcome: welcome()
        });
        commit("SET_AVATAR", result.avatar);
        resolve(result);
      });
    },

    // 登出
    Logout({ commit, state }) {
      return new Promise(resolve => {
        let param = {};
        param.token = state.token;
        const type = Vue.ls.get(ACCOUNT_TYPE);
        if (type == ACCOUNT_TYPE_INFO.SYSTEM) {
          Vue.ls.set(ACCOUNT_TYPE, ACCOUNT_TYPE_INFO.SYSTEM);
          //系统用户退出
          systemBksApi
            .userLogout()
            .then(res => {
              resolve(res);
            })
            .catch(err => {
              resolve(err);
            })
            .finally(() => {
              commit("SET_TOKEN", "");
              commit("SET_ROLES", []);
              commit("SET_PERMSISSION", []);
              commit("SET_INFO", "");
              Vue.ls.remove(ACCESS_TOKEN);
              Vue.ls.remove(USER_INFO);
              Vue.ls.remove(ACCOUNT_TYPE);
            });
        } else {
          Vue.ls.set(ACCOUNT_TYPE, ACCOUNT_TYPE_INFO.NORMAL);
          //普通用户退出
          loginBksApi
            .merchantUserLogout(param)
            .then(() => {
              resolve();
            })
            .catch(() => {
              resolve();
            })
            .finally(() => {
              commit("SET_TOKEN", "");
              commit("SET_ROLES", []);
              commit("SET_PERMSISSION", []);
              commit("SET_INFO", "");
              Vue.ls.remove(ACCESS_TOKEN);
              Vue.ls.remove(USER_INFO);
              Vue.ls.remove(ACCOUNT_TYPE);
            });
        }
      });
    },
    SetUserInfo({ commit }, data) {
      return new Promise(resolve => {
        Vue.ls.set(USER_INFO, data);
        commit("SET_INFO", data);
        commit("SET_NAME", {
          name: data.userName
        });
        resolve();
      });
    }
  }
};

export default user;
